import { Button } from '@mui/material'
import React, { useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EditDialog from '../../../Modals/EditModelDialog';
import ConfirmDialog from '../../../Modals/ConfirmDialog';
import { useDeleteModelMutation, useUpdateModelMutation } from '../../../../features/fullApi';
import { Store } from 'react-notifications-component';


const Model = (model) => {

    const [open, setOpen] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const user = JSON.parse(localStorage.getItem('user'))

    const openModalEditItem = ((model) => {
        setOpenEdit(true)
      })
  
      const [updateModel] = useUpdateModelMutation()
      const [deleteModel] = useDeleteModelMutation()
    
      const message = "Are you sure you want to delete this model ?";
    
      const openDeleteModal = (() => {
        setOpen(true)
      })
    
      const handleUpdateModel = ((model) => {
        setOpenEdit(false)
        updateModel({_id: model.id._id, modelName: model.modelName}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        }).then(
        )
      })
    
    
      const handleDelete = (async (modelId) => {
        deleteModel({id: modelId}).then(
        )
        setOpen(false)
      })

  return (
    <>
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    {user?.isAdmin && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
            <Button aria-label="Edit Item" onClick={() => openModalEditItem(model.model._id)}>
              <EditIcon style={{color: 'orange'}}/>
            </Button>
            <Button aria-label="Delete product" onClick={() => openDeleteModal(model.model._id)} size="small">
            <DeleteIcon style={{color: 'red'}}/>
            </Button>
        </div>
    )}
    </div>
    <EditDialog openEdit={openEdit} handleUpdateModel={handleUpdateModel} setOpenEdit={setOpenEdit} item={model.model}>         
    </EditDialog>
    <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={model.model} message={message}></ConfirmDialog>
  </>
  )
}

export default Model